import type { ReactNode } from 'react';
import { Link } from 'react-router';

export function AuthCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
        <Link to="/" className="mb-6 block text-center text-2xl font-bold tracking-tight">
          planb
        </Link>
        <h1 className="mb-6 text-center text-lg font-semibold text-gray-700">{title}</h1>
        {children}
      </div>
    </main>
  );
}

export function Field({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <label className="mb-4 block">
      <span className="mb-1 block text-sm font-medium text-gray-600">{label}</span>
      {children}
    </label>
  );
}

export const inputClass =
  'w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none';

export const buttonClass =
  'w-full rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-50';

export function FormError({ message }: { message?: string }) {
  if (!message) return null;
  return <p className="mb-4 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{message}</p>;
}

export function FormNotice({ message }: { message?: string }) {
  if (!message) return null;
  return (
    <p className="mb-4 rounded-md bg-green-50 px-3 py-2 text-sm text-green-800">{message}</p>
  );
}
